"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Profile_1 = require("decentraland-ui/dist/components/Profile/Profile");
const actions_1 = require("../../modules/profile/actions");
const selectors_1 = require("../../modules/profile/selectors");
const Profile = function (props) {
    const { address, debounce, inline = true } = props;
    const profiles = (0, react_redux_1.useSelector)(selectors_1.getData);
    const dispatch = (0, react_redux_1.useDispatch)();
    const timeoutRef = (0, react_1.useRef)();
    const avatar = (0, react_1.useMemo)(() => {
        const profile = profiles[address];
        return profile ? profile.avatars[0] : null;
    }, [address, profiles]);
    const onLoadProfile = (0, react_1.useCallback)((address) => dispatch((0, actions_1.loadProfileRequest)(address)), [address]);
    (0, react_1.useEffect)(() => {
        if (!avatar) {
            if (debounce) {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = window.setTimeout(() => onLoadProfile(address), debounce);
            }
            else {
                onLoadProfile(address);
            }
        }
        return () => {
            if (timeoutRef.current) {
                window.clearTimeout(timeoutRef.current);
            }
        };
    }, [address]);
    return react_1.default.createElement(Profile_1.Profile, Object.assign({}, props, { avatar: avatar, inline: inline }));
};
exports.default = Profile;
//# sourceMappingURL=Profile.js.map